/**
 * Loan term options, in months — the unit the API speaks. `term` is always sent
 * as months; weeks are a presentation of the same choice for members on a weekly
 * payment cycle.
 */
export const LOAN_TERM_MONTHS = [96, 84, 72, 60, 48, 36, 24] as const;

const WEEKS_PER_YEAR = 52;
const MONTHS_PER_YEAR = 12;

/**
 * Months to weeks, mirroring the backend so the label matches the week_term the
 * offer comes back with: `n_weeks = ceil((term / 12) * 52)`
 * (calculate_weekly_payment_and_fees in user/contract_flow/utils.py).
 */
export const monthsToWeeks = (months: number): number =>
  Math.ceil((months / MONTHS_PER_YEAR) * WEEKS_PER_YEAR);
